"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoizeComponentByValue = void 0;

var _react = require("react");

var memoizeComponentByValue = function memoizeComponentByValue(Component) {
  return /*#__PURE__*/(0, _react.memo)(Component, function (prev, next) {
    switch (next.config.valueType) {
      case 'Array':
        return next.context[next.config.valueName].value.every(function (val, index) {
          return val === prev.context[prev.config.valueName].value[index];
        }) && prev.context[prev.config.valueName].value.every(function (val, index) {
          return val === next.context[next.config.valueName].value[index];
        });

      case 'Boolean':
      case 'Number':
      case 'String':
        return prev.context[prev.config.valueName].value === next.context[next.config.valueName].value;

      case 'NumberRange':
        return prev.context[prev.config.valueName].value.minimum === next.context[next.config.valueName].value.minimum && prev.context[prev.config.valueName].value.maximum === next.context[next.config.valueName].value.maximum;

      case 'DiagnosticArray':
        {
          var oldValue = prev.context[prev.config.valueName].value.filter(function (e) {
            return e.name === prev.config.identifier;
          })[0] || {};
          var newValue = next.context[next.config.valueName].value.filter(function (e) {
            return e.name === next.config.identifier;
          })[0] || {};
          return oldValue.value === newValue.value;
        }

      case 'LocationType':
        return next.config.withRadius ? prev.context[prev.config.valueName].value.name === next.context[next.config.valueName].value.name && prev.context[prev.config.valueName].value.radius.minimum === next.context[next.config.valueName].value.radius.minimum && prev.context[prev.config.valueName].value.radius.maximum === next.context[next.config.valueName].value.radius.maximum : prev.context[prev.config.valueName].value.name === next.context[next.config.valueName].value.name;

      default:
        return prev.context[prev.config.valueName].value === next.context[next.config.valueName].value;
    }
  });
};

exports.memoizeComponentByValue = memoizeComponentByValue;